import O1HD from "../../../../engines/gameEngine";
import MineLandNode from "./MineLandNode";
import {OreEntity} from "./config/OreConfig";
import getOneBundle, {BUNDLE_SMALL_NAME} from "../../BundleResourceConfig";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class OreItemNode extends cc.Component {

    @property({type:cc.Node,displayName:"遮罩节点数组"})
    shadowNodeArray : cc.Node[] = [];
    @property({type:cc.Node,displayName:"矿石节点"})
    oreSpiritNode : cc.Node = null;

    @property({type:cc.Node,displayName:"判断节点1"})
    judgeNode1 : cc.Node = null;
    @property
    mIndex : number = 0;

    private flag : boolean = false;
    private hasOpenFlag : boolean = false;

    private mOreEntity : OreEntity;
    private mParentScript : MineLandNode;
    private mCurrDigCount : number = 0;//当前挖掘次数

    onLoad () {
        O1HD.on("OreItemNode.checkJudgeNode" , this.checkJudgeNode , this );
        O1HD.on("OreItemNode.activeData" , this.activeData , this );
        O1HD.on("OreItemNode.onDig" , this.onDig , this );
        O1HD.on("OreItemNode.checkEffect" , this.checkEffect , this );
        O1HD.on("OreItemNode.takeAway" , this.takeAway , this );
    }

    start () {
        this.node.getChildByName("shodowNode").active = false;
    }

    /**
     * 激活数据
     */
    activeData( index : number , parentScript : MineLandNode , oreEntity : OreEntity ){
        if( this.mIndex == index ){
            // console.log("激活",this.mIndex,oreEntity);
            this.bindData( parentScript , oreEntity ).then();
        }
    }

    setIndex( index : number ){
        this.mIndex = index;
    }

    /**
     * 绑定数据
     */
    async bindData( parentScript : MineLandNode , oreEntity : OreEntity ){
        this.mParentScript = parentScript;
        this.mOreEntity = oreEntity;
        // 加载矿石数据
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.mineLandGameBundle );
        bundle.load(`assets/ore/${this.mOreEntity.imgPath}` , cc.SpriteFrame , ( error , assets : cc.SpriteFrame )=>{
            if ( error ) {
                console.error( `加载矿石图片失败` ,this.mOreEntity.imgPath );
                return;
            }
            this.oreSpiritNode.getComponent(cc.Sprite).spriteFrame = assets;
        } );
    }

    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.mParentScript && this.digSuccessOpenFlag == false ) {
            if ( this.closeCameraFlag == false ) {
                //设置距离
                let distancePos = this.judgeNode1.convertToWorldSpaceAR(cc.v2()).sub( pos ).mag();
                this.mParentScript.setDistance( distancePos );
            }

            if ( this.judgeNode1.getBoundingBoxToWorld().contains( pos ) ) {
                this.flag = true;
                this._checkFinish();
                return ;
            }
            if ( this.node.getBoundingBoxToWorld().contains( pos ) ) {
                //刚开始触碰
                // 探测仪 声音变急促
                this.mParentScript.soundEffect( 1 );
            }
        }
    }

    /**
     *
     */
    checkEffect( pos : cc.Vec2 ){
        if ( this.mParentScript && this.digSuccessOpenFlag == false ) {
            if ( this.judgeNode1.getBoundingBoxToWorld().contains( pos ) ) {
                this.mParentScript.soundEffect( 2 );
                return ;
            }
            if ( this.node.getBoundingBoxToWorld().contains( pos ) ) {
                //刚开始触碰 探测仪 声音变急促
                this.mParentScript.soundEffect( 1 );
            }
        }
    }

    closeCameraFlag : boolean = false;

    //检查是否完成
    private _checkFinish(){
        if ( this.flag && !this.hasOpenFlag ) {
            this.hasOpenFlag = true;
            this.mParentScript.soundEffect( 2 );
            //1 秒后 再判定

            this.scheduleOnce(()=>{
                let mCurrFingerPos = this.mParentScript.getFingerPos();
                if ( mCurrFingerPos == null ) {
                    this.flag = false;
                    this.hasOpenFlag = false;
                }else if ( this.judgeNode1.getBoundingBoxToWorld().contains( mCurrFingerPos ) ) {
                    this.closeCameraFlag = true;
                    this.pullCloseCamera();
                }else{
                    this.flag = false;
                    this.hasOpenFlag = false;
                }
            },3 );
        }
    }

    /**
     * 拉近镜头
     */
    pullCloseCamera(  ){
        // 该节点的世界坐标   该节点的 实体信息
        if ( this.mParentScript.cameraFlag == false ) {
            //拉近镜头
            this.mParentScript.closeCamera( this.node.convertToWorldSpaceAR(cc.v2()) , this.mOreEntity , this.mIndex );
        }
    }

    //挖矿成功 打开开关
    private digSuccessOpenFlag : boolean = false;
    //正在挖掘 开关
    private digNowFlag : boolean = false;
    /**
     * 挖掘
     */
    onDig( index : number ){
        if ( this.mIndex == index ) {
            this.node.getChildByName("shodowNode").active = true;
            if ( this.mCurrDigCount >= this.shadowNodeArray.length ) {
                return;
            }
            if ( this.digNowFlag ) {
                O1HD.getModules().uiControlModule.showMessageBox("请等待当前挖掘完毕");
                return;
            }

            //
            cc.tween( this.shadowNodeArray[this.mCurrDigCount] )
                .to(1,{opacity:50})
                .call(()=>{
                    this.shadowNodeArray[this.mCurrDigCount].active = false;
                    this.mCurrDigCount++;
                    this.mParentScript.mCurrDigCount ++;
                    // this.lbDigCount.string = `${this.mParentScript.mCurrDigCount}/${this.mParentScript.mCanUseDigCount }`;
                    if ( this.mCurrDigCount == this.shadowNodeArray.length ){
                        this.digSuccessOpenFlag = true;
                        // this.digBtnNode.active = false;
                        this.scheduleOnce(()=>{
                            this.mParentScript.recoveryCamera();
                            this.mParentScript.openSuccessDigNode( this.mOreEntity );
                        },1 );

                    }
                })
                .start();
        }
    }

    // /**
    //  * 显示 挖矿按钮
    //  */
    // showDigBtn(){
    //     this.lbDigCount.string = `${this.mParentScript.mCurrDigCount}/${this.mParentScript.mCanUseDigCount }`;
    //     this.digBtnNode.active = true;
    // }

    //带走
    takeAway( index : number ){
        if ( this.mIndex == index ) {
            this.oreSpiritNode.active = false;
        }
    }




}
